import {createAsyncThunk} from "@reduxjs/toolkit";
import {handlerError} from "../../../store/handleError";
import {fleetDashboardAPI} from "../api";
import {IFleetDashboard} from "../../../models/IFleetDashboard";
import axios from "axios";

// ── Единый запрос флитового дашборда за период ───────────────────────────────

export const fetchFleetDashboard = createAsyncThunk<
    IFleetDashboard,
    { from: string; to: string },
    { rejectValue: string }
>(
    "fleet_dashboard/dashboard",
    async ({from, to}, {rejectWithValue, signal}) => {
        try {
            return await fleetDashboardAPI.getDashboard(from, to, signal);
        } catch (e: unknown) {
            if (
                (e instanceof DOMException && e.name === "AbortError") ||
                axios.isCancel(e)
            ) {
                throw e;
            }
            // 402 уже обработан в axios interceptor — реджектим без шума
            if (axios.isAxiosError(e) && e.response?.status === 402) {
                return rejectWithValue("billing_restricted");
            }
            return rejectWithValue(handlerError(e));
        }
    },
);
